import { DEFAULT_MINOR_UNITS } from "@/data/currencyUnits";
import { resolveMinorUnits } from "./resolveMinorUnits";

// Converts an API amount into the major units `formatCurrency` displays.
export const toMajorUnits = (amount: number, currency?: string): number =>
  amount / (resolveMinorUnits(currency) ?? DEFAULT_MINOR_UNITS);
